<template>
    <b-container>
        <b-row v-if="isIntuitApp" class="d4d-decoration">
        </b-row>
        <b-row v-if="isJAApp" class="ja-decoration">
        </b-row>

        <b-row class="d4d-login">
            
            <b-col cols="12" class="mt-1 title">Check your email</b-col>

            <b-col cols="12" class="mt-3">
                <p class="text pb">We sent an email to <span class="email"> {{this.$route.params.email}} </span> ,
                    click the link in the email to reset your password. </p>
                <p class="text ">If you didn't receive the email, please check your spam/junk folder.</p>
            </b-col>
            <b-col cols="12" class="mt-2 button-content">
                <b-button block variant="primary" :to="{ name: 'Login' }">Continue to Log in</b-button>
            </b-col>

        </b-row>
        <legal-message/>
    </b-container>
</template>

<script>
    import LegalMessage from "../Components/LegalMessage"

    export default {
        name: 'verifyEmailPassword',
        components: {LegalMessage}
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "../Styles/security_styles.styl"

    .email
        font font-sourcesans-bold
        font-size 16px
        color color-4
        line-height 25px
</style>